var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 pr-2",attrs:{"cols":"auto"}},[_c('p',{staticClass:"mb-0",staticStyle:{"font-size":"13px","color":"rgb(115, 114, 114)"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }